import { useState, useEffect } from 'react';
import { Toaster } from 'sonner';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import { authApi } from './services/api';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      const token = localStorage.getItem('admin_token');

      // No token at all — go straight to login
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        // Validate token with the server on every page load/refresh
        const user = await authApi.getCurrentUser();
        if (user && user.isAdmin) {
          setIsAuthenticated(true);
        } else {
          // Token valid but user lost admin access — force logout
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
        }
      } catch {
        // Token expired, invalid, or server unreachable — clear and show login
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
      } finally {
        setIsLoading(false);
      }
    };

    verifySession();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <AdminLogin onLogin={handleLogin} />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  return (
    <>
      <AdminDashboard onLogout={handleLogout} />
      <Toaster position="top-right" richColors />
    </>
  );
}
